import BotaoModelo from "../../components/BotaoModelo";
import ImagemNaoEncontrada from "../../assets/imagens/404.svg";
import PageLayout from "../../layouts/PageLayout";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  min-height: calc(100vh - 300px);
  padding: 4em 4em 0em 4em;

  @media screen and (max-width: 768px) {
    padding: 10em 0em;
  }
`;

const Imagem = styled.img`
  height: auto;
  max-width: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

const Texto = styled.p`
  color: #000;
  font-size: 48px;
  font-weight: 400;
  margin: 0;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

export default function Page404() {
  const navigate = useNavigate();

  const handleVoltar = () => {
    navigate("/");
  };

  return (
    <Container id="paginaNaoEncontrada">
      <Imagem src={ImagemNaoEncontrada} alt="Página não encontrada" />
      <Texto>Página não encontrada</Texto>
      <BotaoModelo
        $backgroundcolor={"#1B5EA4"}
        texto={"Voltar para o início"}
        customOnClick={handleVoltar}
        hrefUrl={null}
        $width={"fit-content"}
      />
    </Container>
  );
}
